export default "mutation modifyDettaglioLatitudine($params: ModifyDettaglioLatitudineParams!) {\n        modifyDettaglioLatitudine(params: $params)\n}";